import { Component, Input, Output, EventEmitter } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from '@ngx-translate/core';

export interface PopUpEditColumn {
  key: string;
  label?: string;
  captionName?: string;
  type?: "number" | "string" | "text" | "select";
  setup?: any;
  height?: string | number;
  disabled?: boolean;
  options?: Array<{value: string; label: string}>;
}

@Component({
  selector: "app-pop-up-common-edit",
  standalone: true,
  imports: [CommonModule, FormsModule,TranslateModule],
  templateUrl: "./pop-up-common-edit.component.html",
  styleUrls: ["./pop-up-common-edit.component.scss"],
})
export class PopUpCommonEditComponent {
  @Input() show = false;
  @Input() columns: Array<PopUpEditColumn> = [];
  @Input() title: string = 'Edit';
  @Input() data: any = {};
  @Output() saveEvent = new EventEmitter<any>();
  @Output() cancelEvent = new EventEmitter<void>();

  editedData: any = {};
  // Format number with commas
  formatNumber(value: any): string {
    if (value === null || value === undefined || value === "") return "";
    const num = Number(value);
    if (isNaN(num)) return value;
    return num.toLocaleString("en-US");
  }

  // Parse number from string with commas
  parseNumber(value: string): number | null {
    if (value === null || value === undefined || value === "") return null;
    const num = Number((value + "").replace(/,/g, ""));
    return isNaN(num) ? null : num;
  }

  // Handler for number input change
  onNumberInput(colKey: string, event: any) {
    const raw = event.target.value;
    const parsed = this.parseNumber(raw);
    this.editedData[colKey] = parsed;
    // Force re-render for formatted value
    event.target.value = this.formatNumber(parsed);
  }
  ngOnChanges() {
    this.editedData = { ...this.data };
    if (
      (!this.columns || this.columns.length === 0) &&
      this.data &&
      typeof this.data === "object"
    ) {
      this.columns = Object.keys(this.data).map((key) => ({
        key,
        label: key,
        captionName: key,
        type: typeof this.data[key] === "number" ? "number" : "string",
        setup: undefined,
        height: undefined,
      }));
    }
  }

  save() {
    this.saveEvent.emit(this.editedData);
  }

  cancel() {
    this.cancelEvent.emit();
  }
}
